exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-56a14811] {\n  cursor: pointer;\n}\n", ""]);

// exports
